module.exports = __webpack_public_path__ + "static/img/11.9f93e32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/sp/11.png
// module id = 9Iep
// module chunks = 0